import '../../base/outline-icon/outline-icon';
import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './idblab-logo.css.lit';

// import logoEn from './assets/logo-en.gif';
// import logoEs from './assets/logo-es.gif';

import logoEn from './assets/idb-logo-en.png';
import logoEs from './assets/idb-logo-es.png';

/**
 * The IDB Lab logo component.
 * @element idblab-logo
 * @extends OutlineElement
 * @property logo - Which logo to use.
 */

export type Logos = 'en' | 'es';
@customElement('idblab-logo')
export class LabLogo extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  private logos = {
    en: `<div slot="image">
          <img src="${logoEn}" alt="Amnimated logo" style="max-width: 200px"/>
        </div>`,
    // @todo: Replace this will real GIF once we have a proper logo.
    es: `<div slot="image">
          <img src="${logoEs}" alt="Logotipo animado" style="max-width: 200px"/>
        </div>`,
  };

  @property({ type: String, attribute: 'logo' })
  logo: Logos = 'en';

  render(): TemplateResult {
    return html`${unsafeHTML(this.logos[this.logo])}`;
  }
}
